import { makeStyles, useMediaQuery } from '@material-ui/core'
import React, { useState } from 'react'
import { Route, Switch } from 'react-router';
import Footer from './components/Footer/Footer';
import Header from './components/Header/Header';
import Introduction from './components/Introduction/Introduction';
import NeonatalForm from './components/NeonatalForm';
import Sidebar from './components/Sidebar/Sidebar';

function App() {

  const mobile = useMediaQuery('(max-width: 400px)')
  const styles = useStyles({ mobile });

  const [isDrawer, setIsDrawer] = useState(false);

  const handleDrawer = (e) => {
    setIsDrawer(!isDrawer);
  }

  // const handleCloseDrawer = () => {
  //   setIsDrawer(false);
  // }

  return (
    <div>
      <Header
        handleDrawer={handleDrawer}
        isDrawer={isDrawer}
      />
      <Sidebar
        isDrawer={isDrawer}
        setIsDrawer={setIsDrawer}
      />

      <Switch>
        <Route exact path='/neonatal'>
          <NeonatalForm />
        </Route>
        <Route exact path='/'>
          <Introduction />
        </Route>
      </Switch>
      <Footer />
    </div>
  )
}

export default App

const useStyles = makeStyles(({

}))
